import { useGlobalStore } from "@/stores/GlobalStore";
import { projectPolicies } from "@/AppConfig";

class PermissionService {
    /*
        gets identifier of policy to look for, and checks if the user has one of the roles listed in the policy-roles

        returns false when user is not set
    */
    public userHasPermission(policyName:string):boolean{
        const globalStore = useGlobalStore();

        const roleList = this.getRolesFromPolicyList(policyName);

        if (globalStore.user === null || globalStore.user === undefined) return false;

        return roleList.some(r => r === globalStore.user?.role);
    }


    /* --- PRIVATE  --- */


    private getRolesFromPolicyList(policyName:string):Array<string>{
        const foundPolicy = projectPolicies.find((i:any) => i.Name === policyName);

        if (foundPolicy === undefined){
            console.log(`[PolicyService], no policy found (${policyName})`)
            return new Array<string>();
        }

        return foundPolicy.Roles.split(", ");
    }
}

export default new PermissionService();
